import { render, staticRenderFns } from "./DaTeacher.vue?vue&type=template&id=2a97a918&"
import script from "./DaTeacher.vue?vue&type=script&lang=js&"
export * from "./DaTeacher.vue?vue&type=script&lang=js&"
import style0 from "./DaTeacher.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports